import {ApprovalState, useApproveCallbackFromTrade} from '../../hooks/useApproveCallback'
import {ArrowWrapper, BottomGrouping, SwapCallbackError, Wrapper} from '../../components/swap/styleds'
import {AutoRow, RowBetween} from '../../components/Row'
import {ButtonConfirmed, ButtonError, ButtonLight, ButtonPrimary} from '../../components/ButtonLegacy'
import Card, {DarkCard, GreyCard} from '../../components/CardLegacy'
import {ChainId, CurrencyAmount, JSBI, Token, Trade} from '@sushiswap/sdk'
import Column, {AutoColumn} from '../../components/Column'
import {LinkStyledButton, TYPE} from '../../theme'
import React, {useCallback, useContext, useEffect, useMemo, useState, Component, useRef} from 'react'
import {computeTradePriceBreakdown, warningSeverity} from '../../utils/prices'
import {useAllTokens, useCurrency} from '../../hooks/Tokens'

import {
    useDefaultsFromURLSearch,
    useDerivedSwapInfo,
    useSwapActionHandlers,
    useSwapState
} from '../../state/swap/hooks'
import {useExpertModeManager, useUserSingleHopOnly, useUserSlippageTolerance} from '../../state/user/hooks'
import {useNetworkModalToggle, useToggleSettingsMenu, useWalletModalToggle} from '../../state/application/hooks'
import useWrapCallback, {WrapType} from '../../hooks/useWrapCallback'

import AddressInputPanel from '../../components/AddressInputPanel'
import AdvancedSwapDetailsDropdown from '../../components/swap/AdvancedSwapDetailsDropdown'
import {ArrowDown} from 'react-feather'
import {ClickableText} from '../Pool/styleds'
import ConfirmSwapModal from '../../components/swap/ConfirmSwapModal'
import CurrencyInputPanel from '../../components/CurrencyInputPanel'
import {Field} from '../../state/swap/actions'
import {Helmet} from 'react-helmet'
import {INITIAL_ALLOWED_SLIPPAGE} from '../../constants'
import {Link} from 'react-router-dom'
import Loader from '../../components/Loader'
import Lottie from 'lottie-react'
import PolygonLogo from '../../assets/images/matic-logo.png'
import ProgressSteps from '../../components/ProgressSteps'
import ReactGA from 'react-ga'
import SwapHeader from '../../components/ExchangeHeader'
import {SwapPoolTabs} from '../../components/NavigationTabs'
import {Text} from 'rebass'
import {ThemeContext} from 'styled-components'
import TokenWarningModal from '../../components/TokenWarningModal'
import TradePrice from '../../components/swap/TradePrice'
import UnsupportedCurrencyFooter from 'components/swap/UnsupportedCurrencyFooter'
import confirmPriceImpactWithoutFee from '../../components/swap/confirmPriceImpactWithoutFee'
import {isTradeBetter} from 'utils/trades'
import {maxAmountSpend} from '../../utils/maxAmountSpend'
import swapArrowsAnimationData from '../../assets/animation/swap-arrows.json'
import {t, Trans} from '@lingui/macro'
import {useActiveWeb3React} from '../../hooks/useActiveWeb3React'
import useENSAddress from '../../hooks/useENSAddress'
import {useIsTransactionUnsupported} from 'hooks/Trades'
import {useLingui} from '@lingui/react'
import {useSwapCallback} from '../../hooks/useSwapCallback'
import MisoBanner from '../../assets/images/miso-banner.jpg'
import MisoLogo from '../../assets/images/miso-logo.png'
import {useUser} from '../../hooks/useUser'
import {useRss} from '../../hooks/useRss'
import {useCurrencyBalance} from "../../state/wallet/hooks";
import axios from "axios";
// import Chart from 'react-apexcharts'
import {Chart, registerables} from "chart.js"
import {Line} from "react-chartjs-2"
import {isMobile} from "react-device-detect";
import Marquee from "react-fast-marquee";

Chart.register(...registerables)

export default function Dashboard() {
    const {i18n} = useLingui()
    const toggleNetworkModal = useNetworkModalToggle()

    const loadedUrlParams = useDefaultsFromURLSearch()

    const userdata = useUser()
    const rss = useRss()
    let count = 1;

    // token warning stuff
    const [loadedInputCurrency, loadedOutputCurrency] = [
        useCurrency(loadedUrlParams?.inputCurrencyId),
        useCurrency(loadedUrlParams?.outputCurrencyId)
    ]
    const [dismissTokenWarning, setDismissTokenWarning] = useState<boolean>(false)
    const urlLoadedTokens: Token[] = useMemo(
        () => [loadedInputCurrency, loadedOutputCurrency]?.filter((c): c is Token => c instanceof Token) ?? [],
        [loadedInputCurrency, loadedOutputCurrency]
    )
    const handleConfirmTokenWarning = useCallback(() => {
        setDismissTokenWarning(true)
    }, [])

    // dismiss warning if all imported tokens are in active lists
    const defaultTokens = useAllTokens()
    const importTokensNotInDefault =
        urlLoadedTokens &&
        urlLoadedTokens.filter((token: Token) => {
            return !Boolean(token.address in defaultTokens)
        })

    const {account, chainId} = useActiveWeb3React()
    const theme = useContext(ThemeContext)

    /** ##### **/

    const currencyETH = useCurrency("ETH")
    const currencyBEGN = useCurrency("0x14eee29F4A62B8FB795D3AEc67543094ea1376df")
    const currencyALTEMA = useCurrency("0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647")
    const currencyUSDT = useCurrency("0xdAC17F958D2ee523a2206206994597C13D831ec7")
    const currencyWBTC = useCurrency("0x2260fac5e5542a773aa44fbcfedf7c193bc2c599")
    const currencySAND = useCurrency("0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84")
    const currencyMATIC = useCurrency("0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0")
    const currencyUNI = useCurrency("0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984")
    const currencyMKR = useCurrency("0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2")
    const currencyGRT = useCurrency("0x514910771AF9Ca656af840dff83E8264EcF986CA")
    const currencyFTM = useCurrency("0x4e15361fd6b4bb609fa63c81a2be19d873717870")
    const currencyNETR = useCurrency("0x07E19B50AFFfcc6FDE8585341332B47560328bB4")
    const currencyMGET = useCurrency("0x96b2F3276C753169f2Db18954Eb59aEA46618e2b")
    const currencyZAXS = useCurrency("0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb")
    const currencyYOSA = useCurrency("0xC018a7c254C3e4139a32fdDb33C9cC568056dbD5")
    const currencyVERU = useCurrency("0x13dfd8e2B5B601CD535F05a8D64B4478063D8Bf5")
    const currencyDTS = useCurrency("0x6B2F7B22A4c6cbbEf4B641392Deb572418E81dC8")

    const balanceETH = useCurrencyBalance(account ?? undefined, currencyETH ?? undefined)
    const balanceBEGN = useCurrencyBalance(account ?? undefined, currencyBEGN ?? undefined)
    const balanceALTEMA = useCurrencyBalance(account ?? undefined, currencyALTEMA ?? undefined)
    const balanceUSDT = useCurrencyBalance(account ?? undefined, currencyUSDT ?? undefined)
    const balanceWBTC = useCurrencyBalance(account ?? undefined, currencyWBTC ?? undefined)
    const balanceSAND = useCurrencyBalance(account ?? undefined, currencySAND ?? undefined)
    const balanceMATIC = useCurrencyBalance(account ?? undefined, currencyMATIC ?? undefined)
    const balanceUNI = useCurrencyBalance(account ?? undefined, currencyUNI ?? undefined)
    const balanceMKR = useCurrencyBalance(account ?? undefined, currencyMKR ?? undefined)
    const balanceGRT = useCurrencyBalance(account ?? undefined, currencyGRT ?? undefined)
    const balanceFTM = useCurrencyBalance(account ?? undefined, currencyFTM ?? undefined)
    const balanceNETR = useCurrencyBalance(account ?? undefined, currencyNETR ?? undefined)
    const balanceMGET = useCurrencyBalance(account ?? undefined, currencyMGET ?? undefined)
    const balanceZAXS = useCurrencyBalance(account ?? undefined, currencyZAXS ?? undefined)
    const balanceYOSA = useCurrencyBalance(account ?? undefined, currencyYOSA ?? undefined)
    const balanceVERU = useCurrencyBalance(account ?? undefined, currencyVERU ?? undefined)
    const balanceDTS = useCurrencyBalance(account ?? undefined, currencyDTS ?? undefined)

    const [usdbit, setusdbit] = useState([])
    const [usdbic, setusdbic] = useState([])
    const [usdeth, setusdeth] = useState([])
    const [usdusd, setusdusd] = useState([])
    const [usdwbtc, setusdwbtc] = useState([])
    const [usdsand, setusdsand] = useState([])
    const [usdmatic, setusdmatic] = useState([])
    const [usduni, setusduni] = useState([])
    const [usdmkr, setusdmkr] = useState([])
    const [usdgrt, setusdgrt] = useState([])
    const [usdftm, setusdftm] = useState([])
    const [usdnetr, setusdnetr] = useState([])
    const [usdmget, setusdmget] = useState([])
    const [usdzaxs, setusdzaxs] = useState([])
    const [usdyosa, setusdyosa] = useState([])
    const [usdveru, setusdveru] = useState([])
    const [usddts, setusddts] = useState([])
    const [usdbit_per, setusdbit_per] = useState([])
    const [usdbic_per, setusdbic_per] = useState([])
    const [usdeth_per, setusdeth_per] = useState([])
    const [usdusd_per, setusdusd_per] = useState([])
    const [usdwbtc_per, setusdwbtc_per] = useState([])
    const [usdsand_per, setusdsand_per] = useState([])
    const [usdmatic_per, setusdmatic_per] = useState([])
    const [usduni_per, setusduni_per] = useState([])
    const [usdmkr_per, setusdmkr_per] = useState([])
    const [usdgrt_per, setusdgrt_per] = useState([])
    const [usdftm_per, setusdftm_per] = useState([])
    const [usdnetr_per, setusdnetr_per] = useState([])
    const [usdmget_per, setusdmget_per] = useState([])
    const [usdzaxs_per, setusdzaxs_per] = useState([])
    const [usdyosa_per, setusdyosa_per] = useState([])
    const [usdveru_per, setusdveru_per] = useState([])
    const [usddts_per, setusddts_per] = useState([])
    const usdbit_array = useRef([])
    const usdbic_array = useRef([])
    const usdeth_array = useRef([])
    const usdusd_array = useRef([])
    const usdwbtc_array = useRef([])
    const usdsand_array = useRef([])
    const usdmatic_array = useRef([])
    const usduni_array = useRef([])
    const usdmkr_array = useRef([])
    const usdgrt_array = useRef([])
    const usdftm_array = useRef([])
    const usdnetr_array = useRef([])
    const usdmget_array = useRef([])
    const usdzaxs_array = useRef([])
    const usdyosa_array = useRef([])
    const usdveru_array = useRef([])
    const usddts_array = useRef([])
    const usdbit_per_array = useRef([])
    const usdbic_per_array = useRef([])
    const usdeth_per_array = useRef([])
    const usdusd_per_array = useRef([])
    const usdwbtc_per_array = useRef([])
    const usdsand_per_array = useRef([])
    const usdmatic_per_array = useRef([])
    const usduni_per_array = useRef([])
    const usdmkr_per_array = useRef([])
    const usdgrt_per_array = useRef([])
    const usdftm_per_array = useRef([])
    const usdnetr_per_array = useRef([])
    const usdmget_per_array = useRef([])
    const usdzaxs_per_array = useRef([])
    const usdyosa_per_array = useRef([])
    const usdveru_per_array = useRef([])
    const usddts_per_array = useRef([])
    const [usdbit_tmp, setusdbit_tmp] = useState([])
    const [usdbic_tmp, setusdbic_tmp] = useState([])
    const [usdeth_tmp, setusdeth_tmp] = useState([])
    const [usdusd_tmp, setusdusd_tmp] = useState([])
    const [usdwbtc_tmp, setusdwbtc_tmp] = useState([])
    const [usdsand_tmp, setusdsand_tmp] = useState([])
    const [usdmatic_tmp, setusdmatic_tmp] = useState([])
    const [usduni_tmp, setusduni_tmp] = useState([])
    const [usdmkr_tmp, setusdmkr_tmp] = useState([])
    const [usdgrt_tmp, setusdgrt_tmp] = useState([])
    const [usdftm_tmp, setusdftm_tmp] = useState([])
    const [usdnetr_tmp, setusdnetr_tmp] = useState([])
    const [usdmget_tmp, setusdmget_tmp] = useState([])
    const [usdzaxs_tmp, setusdzaxs_tmp] = useState([])
    const [usdyosa_tmp, setusdyosa_tmp] = useState([])
    const [usdveru_tmp, setusdveru_tmp] = useState([])
    const [usddts_tmp, setusddts_tmp] = useState([])
    const [usdbit_chart, setusdbit_chart] = useState([])
    const [usdbic_chart, setusdbic_chart] = useState([])
    const [usdeth_chart, setusdeth_chart] = useState([])
    const [usdusd_chart, setusdusd_chart] = useState([])
    const [usdwbtc_chart, setusdwbtc_chart] = useState([])
    const [usdsand_chart, setusdsand_chart] = useState([])
    const [usdmatic_chart, setusdmatic_chart] = useState([])
    const [usduni_chart, setusduni_chart] = useState([])
    const [usdmkr_chart, setusdmkr_chart] = useState([])
    const [usdgrt_chart, setusdgrt_chart] = useState([])
    const [usdftm_chart, setusdftm_chart] = useState([])
    const [usdnetr_chart, setusdnetr_chart] = useState([])
    const [usdmget_chart, setusdmget_chart] = useState([])
    const [usdzaxs_chart, setusdzaxs_chart] = useState([])
    const [usdyosa_chart, setusdyosa_chart] = useState([])
    const [usdveru_chart, setusdveru_chart] = useState([])
    const [usddts_chart, setusddts_chart] = useState([])

    useEffect(() => {
        axios.get("https://account.swapnova.io/api/getrateflash")
            .then(res => {
                usdbit_array.current = res.data["usdbit"]
                usdbic_array.current = res.data["usdbic"]
                usdeth_array.current = res.data["usdeth"]
                usdusd_array.current = res.data["usdusd"]
                usdwbtc_array.current = res.data["usdwbtc"]
                usdsand_array.current = res.data["usdsand"]
                usdmatic_array.current = res.data["usdmatic"]
                usduni_array.current = res.data["usduni"]
                usdmkr_array.current = res.data["usdmkr"]
                usdgrt_array.current = res.data["usdgrt"]
                usdftm_array.current = res.data["usdftm"]
                usdnetr_array.current = res.data["usdnetr"]
                usdmget_array.current = res.data["usdmget"]
                usdzaxs_array.current = res.data["usdzaxs"]
                usdyosa_array.current = res.data["usdyosa"]
                usdveru_array.current = res.data["usdveru"]
                usddts_array.current = res.data["usddts"]
                usdbit_per_array.current = res.data["usdbit_per"]
                usdbic_per_array.current = res.data["usdbic_per"]
                usdeth_per_array.current = res.data["usdeth_per"]
                usdusd_per_array.current = res.data["usdusd_per"]
                usdwbtc_per_array.current = res.data["usdwbtc_per"]
                usdsand_per_array.current = res.data["usdsand_per"]
                usdmatic_per_array.current = res.data["usdmatic_per"]
                usduni_per_array.current = res.data["usduni_per"]
                usdmkr_per_array.current = res.data["usdmkr_per"]
                usdgrt_per_array.current = res.data["usdgrt_per"]
                usdftm_per_array.current = res.data["usdftm_per"]
                usdnetr_per_array.current = res.data["usdnetr_per"]
                usdmget_per_array.current = res.data["usdmget_per"]
                usdzaxs_per_array.current = res.data["usdzaxs_per"]
                usdyosa_per_array.current = res.data["usdyosa_per"]
                usdveru_per_array.current = res.data["usdveru_per"]
                usddts_per_array.current = res.data["usddts_per"]

                count = 1
            })
    }, [])

    useEffect(() => {
        axios.get("https://account.swapnova.io/api/getchartrate")
            .then(res => {
                setusdbit_chart(res.data["usdbit"])
                setusdbic_chart(res.data["usdbic"])
                setusdeth_chart(res.data["usdeth"])
                setusdusd_chart(res.data["usdusd"])
                setusdwbtc_chart(res.data["usdwbtc"])
                setusdsand_chart(res.data["usdsand"])
                setusdmatic_chart(res.data["usdmatic"])
                setusduni_chart(res.data["usduni"])
                setusdmkr_chart(res.data["usdmkr"])
                setusdgrt_chart(res.data["usdgrt"])
                setusdftm_chart(res.data["usdftm"])
                setusdnetr_chart(res.data["usdnetr"])
                setusdmget_chart(res.data["usdmget"])
                setusdzaxs_chart(res.data["usdzaxs"])
                setusdyosa_chart(res.data["usdyosa"])
                setusdveru_chart(res.data["usdveru"])
                setusddts_chart(res.data["usddts"])
            })
    }, [])

    let u_balanceBIT = 0;
    let u_balanceALTEMA = 0;
    let u_balanceETH = null;
    let u_balanceUSD = 0;
    let u_balanceWBTC = 0;
    let u_balanceSAND = 0;
    let u_balanceMATIC = 0;
    let u_balanceUNI = 0;
    let u_balanceMKR = 0;
    let u_balanceGRT = 0;
    let u_balanceFTM = 0;
    let u_balanceNETR = 0;
    let u_balanceMGET = 0;
    let u_balanceZAXS = 0;
    let u_balanceYOSA = 0;
    let u_balanceVERU = 0;
    let u_balanceDTS = 0;
    let d_balanceBIT = null;
    let d_balanceALTEMA = null;
    let d_balanceWBTC = null;
    let d_balanceSAND = null;
    let d_balanceMATIC = null;
    let d_balanceUNI = null;
    let d_balanceMKR = null;
    let d_balanceGRT = null;
    let d_balanceFTM = null;
    let d_balanceETH = null;
    let d_balanceUSD = null;
    let d_balanceNETR = null;
    let d_balanceMGET = null;
    let d_balanceZAXS = null;
    let d_balanceYOSA = null;
    let d_balanceVERU = null;
    let d_balanceDTS = null;
    let total_balance = null;
    let d_total_balance = null;
    let fixedusdbit = null;
    let fixedusdbic = null;
    let fixedusdeth = null;
    let fixedusdusd = null;
    let fixedusdwbtc = null;
    let fixedusdsand = null;
    let fixedusdmatic = null;
    let fixedusduni = null;
    let fixedusdmkr = null;
    let fixedusdgrt = null;
    let fixedusdftm = null;
    let fixedusdnetr = null;
    let fixedusdmget = null;
    let fixedusdzaxs = null;
    let fixedusdyosa = null;
    let fixedusdveru = null;
    let fixedusddts = null;
    let digit = null;
    let splitter = null;

    if (usdbit && balanceBEGN) {
        u_balanceBIT = Number(balanceBEGN.toSignificant(5)) * Number(usdbit)
        d_balanceBIT = Number(u_balanceBIT.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdbit && balanceUSDT) {
        u_balanceUSD = Number(balanceUSDT.toSignificant(5))
        d_balanceUSD = Number(u_balanceUSD.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdbit && balanceETH) {
        u_balanceETH = Number(balanceETH.toSignificant(5)) * Number(usdeth)
        d_balanceETH = Number(u_balanceETH.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdbic && balanceALTEMA) {
        u_balanceALTEMA = Number(balanceALTEMA.toSignificant(5)) * Number(usdbic)
        d_balanceALTEMA = Number(u_balanceALTEMA.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdsand && balanceSAND) {
        u_balanceSAND = Number(balanceSAND.toSignificant(5)) * Number(usdsand)
        d_balanceSAND = Number(u_balanceSAND.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdwbtc && balanceWBTC) {
        u_balanceWBTC = Number(balanceWBTC.toSignificant(5)) * Number(usdwbtc)
        d_balanceWBTC = Number(u_balanceWBTC.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdmatic && balanceMATIC) {
        u_balanceMATIC = Number(balanceMATIC.toSignificant(5)) * Number(usdmatic)
        d_balanceMATIC = Number(u_balanceMATIC.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usduni && balanceUNI) {
        u_balanceUNI = Number(balanceUNI.toSignificant(5)) * Number(usduni)
        d_balanceUNI = Number(u_balanceUNI.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdmkr && balanceMKR) {
        u_balanceMKR = Number(balanceMKR.toSignificant(5)) * Number(usdmkr)
        d_balanceMKR = Number(u_balanceMKR.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdgrt && balanceGRT) {
        u_balanceGRT = Number(balanceGRT.toSignificant(5)) * Number(usdgrt)
        d_balanceGRT = Number(u_balanceGRT.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdftm && balanceFTM) {
        u_balanceFTM = Number(balanceFTM.toSignificant(5)) * Number(usdftm)
        d_balanceFTM = Number(u_balanceFTM.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdnetr && balanceNETR) {
        u_balanceNETR = Number(balanceNETR.toSignificant(5)) * Number(usdnetr)
        d_balanceNETR = Number(u_balanceNETR.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdmget && balanceMGET) {
        u_balanceMGET = Number(balanceMGET.toSignificant(5)) * Number(usdmget)
        d_balanceMGET = Number(u_balanceMGET.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdzaxs && balanceZAXS) {
        u_balanceZAXS = Number(balanceZAXS.toSignificant(5)) * Number(usdzaxs)
        d_balanceZAXS = Number(u_balanceZAXS.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdyosa && balanceYOSA) {
        u_balanceYOSA = Number(balanceYOSA.toSignificant(5)) * Number(usdyosa)
        d_balanceYOSA = Number(u_balanceYOSA.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdveru && balanceVERU) {
        u_balanceVERU = Number(balanceVERU.toSignificant(5)) * Number(usdveru)
        d_balanceVERU = Number(u_balanceVERU.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usddts && balanceDTS) {
        u_balanceDTS = Number(balanceDTS.toSignificant(5)) * Number(usddts)
        d_balanceDTS = Number(u_balanceDTS.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (u_balanceETH) {
        total_balance = u_balanceETH + u_balanceUSD + u_balanceBIT + u_balanceALTEMA + u_balanceFTM + u_balanceWBTC + u_balanceGRT + u_balanceMATIC + u_balanceMKR + u_balanceSAND + u_balanceUNI + u_balanceNETR + u_balanceMGET + u_balanceZAXS + u_balanceYOSA + u_balanceVERU
        d_total_balance = Number(total_balance.toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }

    if (usdbit) {
        digit = 2
        splitter = Number(Number(usdbit).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdbit = Number(usdbit).toLocaleString(undefined, {
                minimumFractionDigits: digit,
                maximumFractionDigits: digit
            }).toLocaleString()
        }
    }

    if (usdbic) {
        digit = 2
        splitter = Number(Number(usdbic).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdbic = Number(usdbic).toLocaleString(undefined, {minimumFractionDigits: 5, maximumFractionDigits: 5})
        }
    }

    if (usdeth) {
        digit = 2
        splitter = Number(Number(usdeth).toString().substr(0, 7)).toString().split('.')
        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdeth = Number(usdeth).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        }
    }

    if (usdusd) {
        digit = 2
        splitter = Number(Number(usdusd).toString().substr(0, 7)).toString().split('.')

        digit = 5
    }

    if (usdwbtc) {
        digit = 2
        splitter = Number(Number(usdwbtc).toString().substr(0, 8)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdwbtc = Number(usdwbtc).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
        }
    }

    if (usdsand) {
        digit = 2
        splitter = Number(Number(usdsand).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdsand = Number(usdsand).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdmatic) {
        digit = 2
        splitter = Number(Number(usdmatic).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdmatic = Number(usdmatic).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usduni) {
        digit = 2
        splitter = Number(Number(usduni).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusduni = Number(usduni).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdmkr) {
        digit = 2
        splitter = Number(Number(usdmkr).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdmkr = Number(usdmkr).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdgrt) {
        digit = 2
        splitter = Number(Number(usdgrt).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdgrt = Number(usdgrt).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdftm) {
        digit = 2
        splitter = Number(Number(usdftm).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdftm = Number(usdftm).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdnetr) {
        digit = 2
        splitter = Number(Number(usdnetr).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdnetr = Number(usdnetr).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdmget) {
        digit = 2
        splitter = Number(Number(usdmget).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdmget = Number(usdmget).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdzaxs) {
        digit = 2
        splitter = Number(Number(usdzaxs).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdzaxs = Number(usdzaxs).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdyosa) {
        digit = 2
        splitter = Number(Number(usdyosa).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdyosa = Number(usdyosa).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdveru) {
        digit = 2
        splitter = Number(Number(usdveru).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdveru = Number(usdveru).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usddts) {
        digit = 2
        splitter = Number(Number(usddts).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusddts = Number(usddts).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    if (usdusd) {
        digit = 2
        splitter = Number(usdusd).toString().substr(0, 7).split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedusdusd = Number(usdusd).toLocaleString(undefined, {minimumFractionDigits: digit, maximumFractionDigits: digit})
        }
    }

    /** ##### **/

        // toggle wallet when disconnected
    const toggleWalletModal = useWalletModalToggle()

    // for expert mode
    const toggleSettings = useToggleSettingsMenu()
    const [isExpertMode] = useExpertModeManager()

    // get custom setting values for user
    const [allowedSlippage] = useUserSlippageTolerance()

    // swap state
    const {independentField, typedValue, recipient} = useSwapState()
    const {v2Trade, currencyBalances, parsedAmount, currencies, inputError: swapInputError} = useDerivedSwapInfo()
    const {wrapType, execute: onWrap, inputError: wrapInputError} = useWrapCallback(
        currencies[Field.INPUT],
        currencies[Field.OUTPUT],
        typedValue
    )

    const showWrap: boolean = wrapType !== WrapType.NOT_APPLICABLE
    const {address: recipientAddress} = useENSAddress(recipient)

    const trade = showWrap ? undefined : v2Trade

    const parsedAmounts = showWrap
        ? {
            [Field.INPUT]: parsedAmount,
            [Field.OUTPUT]: parsedAmount
        }
        : {
            [Field.INPUT]: independentField === Field.INPUT ? parsedAmount : trade?.inputAmount,
            [Field.OUTPUT]: independentField === Field.OUTPUT ? parsedAmount : trade?.outputAmount
        }

    const {onSwitchTokens, onCurrencySelection, onUserInput, onChangeRecipient} = useSwapActionHandlers()
    const isValid = !swapInputError
    const dependentField: Field = independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT

    const handleTypeInput = useCallback(
        (value: string) => {
            onUserInput(Field.INPUT, value)
        },
        [onUserInput]
    )
    const handleTypeOutput = useCallback(
        (value: string) => {
            onUserInput(Field.OUTPUT, value)
        },
        [onUserInput]
    )

    // modal and loading
    const [{showConfirm, tradeToConfirm, swapErrorMessage, attemptingTxn, txHash}, setSwapState] = useState<{
        showConfirm: boolean
        tradeToConfirm: Trade | undefined
        attemptingTxn: boolean
        swapErrorMessage: string | undefined
        txHash: string | undefined
    }>({
        showConfirm: false,
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    })

    const formattedAmounts = {
        [independentField]: typedValue,
        [dependentField]: showWrap
            ? parsedAmounts[independentField]?.toExact() ?? ''
            : parsedAmounts[dependentField]?.toSignificant(6) ?? ''
    }

    const route = trade?.route
    const userHasSpecifiedInputOutput = Boolean(
        currencies[Field.INPUT] &&
        currencies[Field.OUTPUT] &&
        parsedAmounts[independentField]?.greaterThan(JSBI.BigInt(0))
    )
    const noRoute = !route

    // check whether the user has approved the router on the input token
    const [approval, approveCallback] = useApproveCallbackFromTrade(trade, allowedSlippage)

    // check if user has gone through approval process, used to show two step buttons, reset on token change
    const [approvalSubmitted, setApprovalSubmitted] = useState<boolean>(false)

    // mark when a user has submitted an approval, reset onTokenSelection for input field
    useEffect(() => {
        if (approval === ApprovalState.PENDING) {
            setApprovalSubmitted(true)
        }
    }, [approval, approvalSubmitted])

    const maxAmountInput: CurrencyAmount | undefined = maxAmountSpend(currencyBalances[Field.INPUT])
    const atMaxAmountInput = Boolean(maxAmountInput && parsedAmounts[Field.INPUT]?.equalTo(maxAmountInput))

    // the callback to execute the swap
    const {callback: swapCallback, error: swapCallbackError} = useSwapCallback(trade, allowedSlippage, recipient)

    const {priceImpactWithoutFee} = computeTradePriceBreakdown(trade)

    const [singleHopOnly] = useUserSingleHopOnly()

    const handleSwap = useCallback(() => {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee)) {
            return
        }
        if (!swapCallback) {
            return
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm,
            showConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        })

        // console.error(userdata["user"])

        swapCallback()
            .then(hash => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: undefined,
                    txHash: hash
                })
                ReactGA.event({
                    category: 'Swap',
                    action:
                        recipient === null
                            ? 'Swap w/o Send'
                            : (recipientAddress ?? recipient) === account
                            ? 'Swap w/o Send + recipient'
                            : 'Swap w/ Send',
                    label: [
                        trade?.inputAmount?.currency?.getSymbol(chainId),
                        trade?.outputAmount?.currency?.getSymbol(chainId)
                    ].join('/')
                })

                ReactGA.event({
                    category: 'Routing',
                    action: singleHopOnly ? 'Swap with multihop disabled' : 'Swap with multihop enabled'
                })
            })
            .catch(error => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: error.message,
                    txHash: undefined
                })
            })
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        showConfirm,
        recipient,
        recipientAddress,
        account,
        trade,
        chainId,
        singleHopOnly
    ])

    // errors
    const [showInverted, setShowInverted] = useState<boolean>(false)

    // warnings on slippage
    const priceImpactSeverity = warningSeverity(priceImpactWithoutFee)

    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    const showApproveFlow =
        !swapInputError &&
        (approval === ApprovalState.NOT_APPROVED ||
            approval === ApprovalState.PENDING ||
            (approvalSubmitted && approval === ApprovalState.APPROVED)) &&
        !(priceImpactSeverity > 3 && !isExpertMode)

    const handleConfirmDismiss = useCallback(() => {
        setSwapState({showConfirm: false, tradeToConfirm, attemptingTxn, swapErrorMessage, txHash})
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(Field.INPUT, '')
        }
    }, [attemptingTxn, onUserInput, swapErrorMessage, tradeToConfirm, txHash])

    const handleAcceptChanges = useCallback(() => {
        setSwapState({tradeToConfirm: trade, swapErrorMessage, txHash, attemptingTxn, showConfirm})
    }, [attemptingTxn, showConfirm, swapErrorMessage, trade, txHash])

    const handleInputSelect = useCallback(
        inputCurrency => {
            setApprovalSubmitted(false) // reset 2 step UI for approvals
            onCurrencySelection(Field.INPUT, inputCurrency)
        },
        [onCurrencySelection]
    )

    const handleMaxInput = useCallback(() => {
        maxAmountInput && onUserInput(Field.INPUT, maxAmountInput.toExact())
    }, [maxAmountInput, onUserInput])

    const handleOutputSelect = useCallback(outputCurrency => onCurrencySelection(Field.OUTPUT, outputCurrency), [
        onCurrencySelection
    ])

    const swapIsUnsupported = useIsTransactionUnsupported(currencies?.INPUT, currencies?.OUTPUT)

    const [animateSwapArrows, setAnimateSwapArrows] = useState<boolean>(false)

    useEffect(() => {
        const interval1 = setInterval(() => {
            setusdbit(usdbit_array.current?.[count])
            setusdbic(usdbic_array.current?.[count])
            setusdeth(usdeth_array.current?.[count])
            setusdusd(usdusd_array.current?.[count])
            setusdwbtc(usdwbtc_array.current?.[count])
            setusdsand(usdsand_array.current?.[count])
            setusdmatic(usdmatic_array.current?.[count])
            setusduni(usduni_array.current?.[count])
            setusdmkr(usdmkr_array.current?.[count])
            setusdgrt(usdgrt_array.current?.[count])
            setusdftm(usdftm_array.current?.[count])
            setusdnetr(usdnetr_array.current?.[count])
            setusdmget(usdmget_array.current?.[count])
            setusdzaxs(usdzaxs_array.current?.[count])
            setusdyosa(usdyosa_array.current?.[count])
            setusdveru(usdveru_array.current?.[count])
            setusddts(usddts_array.current?.[count])
            setusdbit_per(usdbit_per_array.current?.[count])
            setusdbic_per(usdbic_per_array.current?.[count])
            setusdeth_per(usdeth_per_array.current?.[count])
            setusdusd_per(usdusd_per_array.current?.[count])
            setusdwbtc_per(usdwbtc_per_array.current?.[count])
            setusdsand_per(usdsand_per_array.current?.[count])
            setusdmatic_per(usdmatic_per_array.current?.[count])
            setusduni_per(usduni_per_array.current?.[count])
            setusdmkr_per(usdmkr_per_array.current?.[count])
            setusdgrt_per(usdgrt_per_array.current?.[count])
            setusdftm_per(usdftm_per_array.current?.[count])
            setusdnetr_per(usdnetr_per_array.current?.[count])
            setusdmget_per(usdmget_per_array.current?.[count])
            setusdzaxs_per(usdzaxs_per_array.current?.[count])
            setusdyosa_per(usdyosa_per_array.current?.[count])
            setusdveru_per(usdveru_per_array.current?.[count])
            setusddts_per(usddts_per_array.current?.[count])
            setusdbit_tmp(usdbit_array.current?.[count - 1])
            setusdbic_tmp(usdbic_array.current?.[count - 1])
            setusdeth_tmp(usdeth_array.current?.[count - 1])
            setusdusd_tmp(usdusd_array.current?.[count - 1])
            setusdwbtc_tmp(usdwbtc_array.current?.[count - 1])
            setusdsand_tmp(usdsand_array.current?.[count - 1])
            setusdmatic_tmp(usdmatic_array.current?.[count - 1])
            setusduni_tmp(usduni_array.current?.[count - 1])
            setusdmkr_tmp(usdmkr_array.current?.[count - 1])
            setusdgrt_tmp(usdgrt_array.current?.[count - 1])
            setusdftm_tmp(usdftm_array.current?.[count - 1])
            setusdnetr_tmp(usdnetr_array.current?.[count - 1])
            setusdmget_tmp(usdmget_array.current?.[count - 1])
            setusdzaxs_tmp(usdzaxs_array.current?.[count - 1])
            setusdyosa_tmp(usdyosa_array.current?.[count - 1])
            setusdveru_tmp(usdveru_array.current?.[count - 1])
            setusddts_tmp(usddts_array.current?.[count - 1])
            count = count + 1

        }, 2000);
    }, [])

    useEffect(() => {
        const interval2 = setInterval(() => {
            axios.get("https://account.swapnova.io/api/getrateflash")
                .then(res => {
                    usdbit_array.current = res.data["usdbit"]
                    usdbic_array.current = res.data["usdbic"]
                    usdeth_array.current = res.data["usdeth"]
                    usdusd_array.current = res.data["usdusd"]
                    usdwbtc_array.current = res.data["usdwbtc"]
                    usdsand_array.current = res.data["usdsand"]
                    usdmatic_array.current = res.data["usdmatic"]
                    usduni_array.current = res.data["usduni"]
                    usdmkr_array.current = res.data["usdmkr"]
                    usdgrt_array.current = res.data["usdgrt"]
                    usdftm_array.current = res.data["usdftm"]
                    usdnetr_array.current = res.data["usdnetr"]
                    usdmget_array.current = res.data["usdmget"]
                    usdzaxs_array.current = res.data["usdzaxs"]
                    usdyosa_array.current = res.data["usdyosa"]
                    usdveru_array.current = res.data["usdveru"]
                    usddts_array.current = res.data["usddts"]
                    usdbit_per_array.current = res.data["usdbit_per"]
                    usdbic_per_array.current = res.data["usdbic_per"]
                    usdeth_per_array.current = res.data["usdeth_per"]
                    usdusd_per_array.current = res.data["usdusd_per"]
                    usdwbtc_per_array.current = res.data["usdwbtc_per"]
                    usdsand_per_array.current = res.data["usdsand_per"]
                    usdmatic_per_array.current = res.data["usdmatic_per"]
                    usduni_per_array.current = res.data["usduni_per"]
                    usdmkr_per_array.current = res.data["usdmkr_per"]
                    usdgrt_per_array.current = res.data["usdgrt_per"]
                    usdftm_per_array.current = res.data["usdftm_per"]
                    usdnetr_per_array.current = res.data["usdnetr_per"]
                    usdmget_per_array.current = res.data["usdmget_per"]
                    usdzaxs_per_array.current = res.data["usdzaxs_per"]
                    usdyosa_per_array.current = res.data["usdyosa_per"]
                    usdveru_per_array.current = res.data["usdveru_per"]
                    usddts_per_array.current = res.data["usddts_per"]

                    count = 1
                })
        }, 60000)
    }, [])

    return (
        <>
            <Helmet>
                <title>NOVASWAP</title>
                <meta
                    name="description"
                    content="NOVASWAP allows for swapping of ERC20 compatible tokens across multiple networks"
                />
            </Helmet>
            <SwapPoolTabs active={'dashboard'}/>
            {(() => {
                // return <div className="c-assets">
                //     <div className="c-assets__inner u-flex--pc">
                //         <div className="c-assets__content">
                //             <div className="c-assets__wallet">
                //                 <a href="javascript:void(0)" onClick={toggleWalletModal}>Connect to Wallet</a>
                //             </div>
                //         </div>
                //     </div>
                // </div>
                //
                return (
                    <div id="container" className="p_top">
                        <main>
                            <div className="ctTop">
                                <div className="txt">
                                    <div className="row">
                                        <div className="txt_inner">
                                            <h2>Effortless<br/> Token Trades,<br/> Tailored for You.</h2>
                                            <p>Opening new dimensions of digital tokens with a forward-thinking decentralized exchange. <br/>An innovative,
                                                secure, and user-friendly platform.</p>
                                            <ul>
                                                <li><a href="/swap" className="btn st2">Swap</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <figure>
                                    <img src="/front/img/cc.png" alt=""/>
                                </figure>
                            </div>
                            {/*<div className="ctMid">*/}
                            {/*    <div className="row">*/}
                            {/*        <div className="ctMid_top">*/}
                            {/*            <figure>*/}
                            {/*                <img src="/front/img/cat.png" alt=""/>*/}
                            {/*            </figure>*/}
                            {/*            <div className="txt">*/}
                            {/*                <h2>Check Real-Time <br/> Cryptocurrency with NovaSwap!</h2>*/}
                            {/*                <p>At NovaSwap, you can monitor cryptocurrency prices in real-time and use advanced tools to check the current*/}
                            {/*                    market conditions and the price changes of tradable cryptocurrencies.</p>*/}
                            {/*                <p>Prices are based on NovaSwap prices in USD and USDT. Some cryptocurrencies are only available for*/}
                            {/*                    crypto-to-crypto trading pairs, while others can be traded in crypto-to-fiat currency pairs.</p>*/}
                            {/*                <p>Clicking the &apos;Swap&apos; button allows you to easily access the appropriate market. Cryptocurrencies*/}
                            {/*                    displayed in USD are in the USD market, while those displayed in USDT are in the USDT market.</p>*/}
                            {/*/!*            </div>*!/*/}
                            {/*        </div>*/}
                            {/*        <div className="ctMid_bot">*/}
                            {/*            <dl>*/}
                            {/*                <dt>*/}
                            {/*                    <span>Swap trending tokens</span>*/}
                            {/*                </dt>*/}
                            {/*                <dd>You can swap all the latest trending tokens in one place.</dd>*/}
                            {/*            </dl>*/}
                            {/*            <dl>*/}
                            {/*                <dt>*/}
                            {/*                    <span>Find the best rates</span>*/}
                            {/*                </dt>*/}
                            {/*                <dd>The swap feature guarantees a wide range of tokens and the best prices.</dd>*/}
                            {/*            </dl>*/}
                            {/*            <dl>*/}
                            {/*                <dt>*/}
                            {/*                    <span>Slippage Protection</span>*/}
                            {/*                </dt>*/}
                            {/*                <dd>Orders are spread across multiple DEXs to minimize the impact of slippage on settlement prices.</dd>*/}
                            {/*            </dl>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="ctBot">
                                <div className="row">
                                    <h2>Cryptocurrencies</h2>
                                    <div className="listCoin">
                                        <div className="listCoin_head show_pc">
                                            <div className="df">
                                                <div className="df_l">
                                                    <div className="df_l_01">Name</div>
                                                    <div className="df_l_02">
                                                        <div className="df_l_02_01">Price</div>
                                                        <div className="df_l_02_02">24H</div>
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                </div>
                                            </div>
                                        </div>
                                        <div className="listCoin_bd">
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/front/img/btc.png" alt=""/>
                                                            </figure>
                                                            <span>Bitcoin</span>
                                                            <small>WBTC</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdwbtc_tmp < usdwbtc) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdwbtc}</div>
                                                            } else if (usdwbtc_tmp > usdwbtc) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdwbtc}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdwbtc}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdwbtc_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdwbtc_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdwbtc_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/front/img/eth.png" alt=""/>
                                                            </figure>
                                                            <span>Etherium</span>
                                                            <small>ETH</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdeth_tmp < usdeth) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdeth}</div>
                                                            } else if (usdeth_tmp > usdeth) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdeth}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdeth}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdeth_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdeth_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdeth_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0xdAC17F958D2ee523a2206206994597C13D831ec7">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_set.png" alt=""/>
                                                            </figure>
                                                            <span>Space Economy Token</span>
                                                            <small>SET</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdbit_tmp < usdbit) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdbit}</div>
                                                            } else if (usdbit_tmp > usdbit) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdbit}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdbit}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdbit_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdbit_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdbit_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0xc4B79769AbD62C46Ab3808381e2ce0E7dFD239D1">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_bot.jpg" alt=""/>
                                                            </figure>
                                                            <span>Botnomy</span>
                                                            <small>BOT</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdveru_tmp < usdveru) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdveru}</div>
                                                            } else if (usdveru_tmp > usdveru) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdveru}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdveru}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdveru_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdveru_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdveru_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x13dfd8e2B5B601CD535F05a8D64B4478063D8Bf5">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/front/img/usdt.png" alt=""/>
                                                            </figure>
                                                            <span>Tether</span>
                                                            <small>USDT</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdusd_tmp < usdusd) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdusd}</div>
                                                            } else if (usdusd_tmp > usdusd) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdusd}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdusd}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdusd_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdusd_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdusd_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=0xdAC17F958D2ee523a2206206994597C13D831ec7&outputCurrency=ETH">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_gct.jpg" alt=""/>
                                                            </figure>
                                                            <span>Green Carbon Token</span>
                                                            <small>GCT</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdyosa_tmp < usdyosa) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdyosa}</div>
                                                            } else if (usdyosa_tmp > usdyosa) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdyosa}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdyosa}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdyosa_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdyosa_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdyosa_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0xC018a7c254C3e4139a32fdDb33C9cC568056dbD5">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_dts.jpg" alt=""/>
                                                            </figure>
                                                            <span>D10S</span>
                                                            <small>DTS</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usddts_tmp < usddts) {
                                                                return <div className="df_l_02_01 green">$ {fixedusddts}</div>
                                                            } else if (usddts_tmp > usddts) {
                                                                return <div className="df_l_02_01 red">$ {fixedusddts}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusddts}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usddts_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usddts_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usddts_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x6B2F7B22A4c6cbbEf4B641392Deb572418E81dC8">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_bsc.png" alt=""/>
                                                            </figure>
                                                            <span>Bones Cat</span>
                                                            <small>BSC</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdbic_tmp < usdbic) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdbic}</div>
                                                            } else if (usdbic_tmp > usdbic) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdbic}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdbic}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdbic_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdbic_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdbic_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/front/img/steth.png" alt=""/>
                                                            </figure>
                                                            <span>Lido Staked ETH</span>
                                                            <small>stETH</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdsand_tmp < usdsand) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdsand}</div>
                                                            } else if (usdsand_tmp > usdsand) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdsand}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdsand}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdsand_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdsand_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdsand_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_stk.png" alt=""/>
                                                            </figure>
                                                            <span>Stryker</span>
                                                            <small>STK</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdnetr_tmp < usdnetr) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdnetr}</div>
                                                            } else if (usdnetr_tmp > usdnetr) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdnetr}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdnetr}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdnetr_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdnetr_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdnetr_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x07E19B50AFFfcc6FDE8585341332B47560328bB4">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_bcc.png" alt=""/>
                                                            </figure>
                                                            <span>BCST Crypto Index</span>
                                                            <small>BCC</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdzaxs_tmp < usdzaxs) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdzaxs}</div>
                                                            } else if (usdzaxs_tmp > usdzaxs) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdzaxs}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdzaxs}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdzaxs_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdzaxs_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdzaxs_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/UNI.png" alt=""/>
                                                            </figure>
                                                            <span>Uniswap</span>
                                                            <small>UNI</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usduni_tmp < usduni) {
                                                                return <div className="df_l_02_01 green">$ {fixedusduni}</div>
                                                            } else if (usduni_tmp > usduni) {
                                                                return <div className="df_l_02_01 red">$ {fixedusduni}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusduni}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usduni_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usduni_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usduni_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/front/img/chainlink.png" alt=""/>
                                                            </figure>
                                                            <span>ChainLink</span>
                                                            <small>LINK</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdgrt_tmp < usdgrt) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdgrt}</div>
                                                            } else if (usdgrt_tmp > usdgrt) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdgrt}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdgrt}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdgrt_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdgrt_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdgrt_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x514910771AF9Ca656af840dff83E8264EcF986CA">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img src="/images/token-logo_fnt.png" alt=""/>
                                                            </figure>
                                                            <span>FineNet Token</span>
                                                            <small>FNT</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdmget_tmp < usdmget) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdmget}</div>
                                                            } else if (usdmget_tmp > usdmget) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdmget}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdmget}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdmget_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdmget_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdmget_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x96b2F3276C753169f2Db18954Eb59aEA46618e2b">Trade</a>
                                                </div>
                                            </div>
                                            <div className="df item">
                                                <div className="df_l">
                                                    <div className="df_l_01">
                                                        <div className="itemCoin">
                                                            <figure>
                                                                <img
                                                                    src="https://raw.githubusercontent.com/sushiswap/assets/master/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png"
                                                                    alt=""/>
                                                            </figure>
                                                            <span>Maker</span>
                                                            <small>MKR</small>
                                                        </div>
                                                    </div>
                                                    <div className="df_l_02">
                                                        {(() => {
                                                            if (usdmkr_tmp < usdmkr) {
                                                                return <div className="df_l_02_01 green">$ {fixedusdmkr}</div>
                                                            } else if (usdmkr_tmp > usdmkr) {
                                                                return <div className="df_l_02_01 red">$ {fixedusdmkr}</div>
                                                            } else {
                                                                return <div className="df_l_02_01">$ {fixedusdmkr}</div>
                                                            }
                                                        })()}
                                                        {(() => {
                                                            if (Number(usdmkr_per) >= 0) {
                                                                return <div className="df_l_02_02 green"> +{usdmkr_per}%</div>
                                                            } else {
                                                                return <div className="df_l_02_02 red"> {usdmkr_per}%</div>
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className="df_r">
                                                    <a className="btn_trading"
                                                       href="/swap?inputCurrency=ETH&outputCurrency=0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2">Trade</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                        <footer className="footer show_pc" id="footer">
                            <p>&copy; NovaSwap All Rights Reserved.</p>
                        </footer>
                    </div>
                );
            })()}
        </>
    )
}
